<template>
    <pendo-input
        ref="searchInput"
        v-bind="$attrs"
        class="search-input"
        :class="{
            'search-input--full-width': fullWidth,
        }"
        :debounce="debounce"
        :disabled="disabled"
        :placeholder="placeholder || $t('searchInput.Search')"
        :value="value"
        @focus="$emit('focus', $event)"
        @keydown="$emit('keydown', $event)"
        @input="$emit('input', $event)">
        <template #prefix>
            <pendo-loading-indicator
                v-if="loading"
                :spinner-props="{ size: 16 }" />
            <pendo-icon
                v-else
                type="search"
                stroke="var(--palette-gray-100)"
                size="16" />
        </template>
        <template #suffix>
            <pendo-icon-button
                v-if="!isSearchEmpty && !loading"
                class="clear-search"
                icon="x"
                :aria-label="$t('searchInput.Clear search text')"
                @keyup.enter="onSearchClear"
                @click="onSearchClear" />
        </template>
    </pendo-input>
</template>

<script>
import { PendoInput, PendoIcon, PendoIconButton, PendoLoadingIndicator } from '@pendo/components';

export default {
    name: 'Search',
    components: {
        PendoInput,
        PendoIcon,
        PendoIconButton,
        PendoLoadingIndicator,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        debounce: {
            type: [Boolean, Number],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input', 'input-cleared', 'keydown', 'focus'],
    computed: {
        isSearchEmpty () {
            return String(this.value).length <= 0;
        },
    },
    mounted () {
        if (this.autofocus) {
            this.$nextTick(() => {
                this.focusSearchInput();
            });
        }
    },
    methods: {
        focusSearchInput () {
            this.$refs.searchInput.focus();
        },
        // Public method
        // eslint-disable-next-line internal-rules/no-unused-properties
        blurSearchInput () {
            this.$refs.searchInput.blur();
        },
        onSearchClear () {
            this.$emit('input', '');
            this.$emit('input-cleared');
        },
    },
};
</script>

<style lang="less" scoped>
.search-input {
    // the pendo-input component does some js stuff and sets `style="width: 100%"`
    // so we'll just constrain its size via min/max width
    min-width: 208px;
    max-width: 208px;

    &.search-input--full-width {
        max-width: 100%;
    }

    :deep(.pendo-input__suffix) {
        position: absolute;
        right: -4px;
        height: 80%;

        .clear-search {
            height: 100%;
            outline-offset: -2px;
        }
    }
}
</style>
